var _rect, _path, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _rect7, _path5, _g, _rect8, _path6, _path7, _rect9, _rect10, _rect11, _rect12, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPatientDecreeInit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 99,
    viewBox: "0 0 92 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.2139,
    width: 71.5021,
    height: 81.9658,
    rx: 2,
    transform: "rotate(15 22.2139 0)",
    fill: "#3D83BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4582 75.6963C45.3709 77.0157 45.1491 78.9386 43.5533 79.8739C43.3212 80.0099 42.9332 79.906 42.9619 79.6163C43.1077 76.6075 43.3884 75.4685 44.5237 72.6009C45.0013 71.3661 45.7081 71.0103 45.6028 71.4033L45.4333 71.8535C44.6022 74.1335 43.5762 76.4109 43.6537 78.86C44.8864 77.7284 45.1434 75.7653 46.4507 74.6288C46.6372 74.4806 46.9505 74.5893 47.015 74.8048C47.5334 76.4305 47.1209 78.4262 47.8528 79.9852C48.8757 82.1921 50.4778 79.4991 51.7027 78.7618C52.341 78.3877 52.9073 78.4651 53.2793 79.0852C54.3016 80.7467 54.8007 83.631 57.4365 83.47C57.9135 83.4243 57.3641 83.6488 56.8705 83.6652C55.3256 83.7716 54.2194 83.1531 53.496 81.7451C53.0823 80.9156 52.669 78.6243 51.2665 79.9335C50.7174 80.4306 50.3076 81.1385 49.7191 81.6003C47.185 83.5727 46.7656 77.8354 46.4582 75.6963Z",
    fill: "#2C3A64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4424,
    y: 80.108,
    width: 32.2631,
    height: 0.871977,
    rx: 0.435988,
    transform: "rotate(15 31.4424 80.108)",
    fill: "#4B81AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7884 18.5408C53.2549 18.3979 52.7066 18.7144 52.5636 19.2479L51.8821 21.7913L49.3391 21.1099C48.8056 20.967 48.2573 21.2836 48.1143 21.817L47.8797 22.6927C47.7367 23.2262 48.0533 23.7745 48.5868 23.9175L51.1298 24.5989L50.4483 27.1425C50.3053 27.6759 50.6219 28.2243 51.1554 28.3672L52.0311 28.6019C52.5645 28.7448 53.1129 28.4282 53.2558 27.8948L53.9374 25.3512L56.4814 26.0328C57.0148 26.1758 57.5632 25.8592 57.7061 25.3257L57.9407 24.45C58.0837 23.9166 57.7671 23.3682 57.2336 23.2253L54.6897 22.5436L55.3712 20.0002C55.5141 19.4667 55.1975 18.9184 54.6641 18.7754L53.7884 18.5408Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3574,
    y: 37.0921,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 39.3574 37.0921)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2949,
    y: 52.2528,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 35.2949 52.2528)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7773,
    y: 42.9879,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 37.7773 42.9879)",
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7148,
    y: 58.1487,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 33.7148 58.1487)",
    fill: "#4B81AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.527 38.5347L26.3768 41.7385L32.7845 38.0391",
    stroke: "#4B81AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6901 52.8532L22.5399 56.057L28.9476 52.3576",
    stroke: "#4B81AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00292969,
    y: 16.0555,
    width: 71.5021,
    height: 81.9658,
    rx: 2,
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.013 82.8977C42.3042 84.4535 42.5877 86.3683 41.2883 87.6847C41.0993 87.8762 40.6977 87.8762 40.6504 87.589C40.0125 84.6449 39.9889 83.4721 40.3433 80.4084C40.485 79.092 41.0757 78.5654 41.0757 78.9723L41.0284 79.451C40.8158 81.8685 40.4142 84.3338 41.1229 86.6794C42.0207 85.2673 41.7608 83.3046 42.7295 81.8685C42.8712 81.677 43.202 81.7009 43.3201 81.8924C44.2415 83.3285 44.3597 85.363 45.4701 86.6794C47.0294 88.5464 47.8799 85.5305 48.8722 84.5013C49.392 83.9748 49.959 83.903 50.4788 84.4056C51.8963 85.746 53.1249 88.4028 55.6292 87.565C56.0781 87.3975 55.6056 87.7565 55.1331 87.9001C53.6683 88.4028 52.4397 88.0916 51.3766 86.9188C50.7623 86.2247 49.77 84.1184 48.7541 85.746C48.3525 86.3683 48.1398 87.1581 47.6909 87.7565C45.7536 90.3176 43.8635 84.8843 43.013 82.8977Z",
    fill: "#2C3A64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_2796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6878 83.8859L59.5939 83.8938L56.0495 87.4382L56.0407 87.5317L56.1309 87.558L62.8432 84.6262L62.8833 84.5836L64.0178 81.4219L64.0003 81.3447L61.853 79.197L61.7712 79.1815L58.7806 80.4864L58.7422 80.5247L55.8096 87.2358L55.8354 87.3264L55.9293 87.3176L59.4733 83.7741L59.4812 83.6798C59.2484 83.3485 59.2784 82.889 59.5743 82.5932C59.9064 82.2623 60.443 82.2623 60.7752 82.5932C61.1057 82.9253 61.1057 83.4615 60.7752 83.7937C60.4785 84.0896 60.0195 84.1192 59.6878 83.8859Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1602 71.6113L71.7565 76.2067C77.3538 70.4375 83.9101 61.8899 82.6933 60.6736C81.4774 59.4572 72.9299 66.0135 67.1602 71.6113Z",
    fill: "#40946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3229 80.044C64.3736 81.0952 64.9987 82.2423 68.4175 79.3781L63.9893 74.9499C61.1251 78.3682 62.2722 78.9933 63.3229 80.044Z",
    fill: "#40946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4174 79.3781C68.8026 79.0555 69.2232 78.6816 69.6834 78.2514L65.1159 73.6835C64.6857 74.1441 64.3114 74.5652 63.9893 74.9499L68.4174 79.3781Z",
    fill: "#2B7B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1162 73.6835L69.6837 78.2514C70.0864 77.875 70.5166 77.4598 70.9844 76.9921C71.2389 76.738 71.4964 76.4742 71.7564 76.2068L67.1605 71.6113C66.893 71.8704 66.6297 72.1287 66.3747 72.3832C65.9078 72.8506 65.4922 73.2808 65.1162 73.6835Z",
    fill: "#2B7B54"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6504,
    y: 91.0455,
    width: 32.2631,
    height: 0.871977,
    rx: 0.435988,
    fill: "#4B81AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4737 30.8791C44.4737 35.6949 40.5697 39.5988 35.7539 39.5988C30.9382 39.5988 27.0342 35.6949 27.0342 30.8791C27.0342 26.0633 30.9382 22.1593 35.7539 22.1593C40.5697 22.1593 44.4737 26.0633 44.4737 30.8791Z",
    fill: "#E23E5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3005 25.7924C34.7482 25.7924 34.3005 26.2401 34.3005 26.7924V29.4257H31.667C31.1147 29.4257 30.667 29.8734 30.667 30.4257V31.3323C30.667 31.8845 31.1147 32.3323 31.667 32.3323H34.3005V34.9654C34.3005 35.5177 34.7482 35.9655 35.3005 35.9655H36.2071C36.7594 35.9655 37.2071 35.5177 37.2071 34.9655V32.3323H39.8401C40.3923 32.3323 40.8401 31.8845 40.8401 31.3323V30.4257C40.8401 29.8734 40.3923 29.4257 39.8401 29.4257H37.2071V26.7924C37.2071 26.2401 36.7594 25.7924 36.2071 25.7924H35.3005Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1621,
    y: 47.4466,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    fill: "#4B81AC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1621,
    y: 63.1422,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    fill: "#4B81AC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1621,
    y: 53.5505,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    fill: "#4B81AC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1621,
    y: 69.246,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    fill: "#4B81AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 52.6785L14.8269 55.2944L20.0587 50.0625",
    stroke: "#4B81AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 67.5021L14.8269 70.118L20.0587 64.8862",
    stroke: "#4B81AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_2796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0313,
    height: 27.0313,
    fill: "white",
    transform: "translate(55.8096 60.5263)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPatientDecreeInit);
export default __webpack_public_path__ + "static/media/imgPatientDecreeInit.87e04713a4b982a0d6c07f2a3c38583b.svg";
export { ForwardRef as ReactComponent };